export default __webpack_public_path__ + "static/media/I0003.b3016931.png";